import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=afa325c4&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afa325c4')) {
      api.createRecord('afa325c4', component.options)
    } else {
      api.reload('afa325c4', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=afa325c4&", function () {
      api.rerender('afa325c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2PN6tOCxVLPMQ/JS/comp/FavElement.vue"
export default component.exports